import React, { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../store/store';
import { getCampaignsLoading } from '../../store/selector/common.selector';
import { getBrandCampaigns, getDefaultCampaigns } from '../../store/selector/campaign.selector';
import NewCampaignPlan from '../../components/campaignPlan/NewCampaignPlan';
import CampaignPlan from '../../components/campaignPlan/CampaignPlan';
import CampaignPlanLoader from '../../components/campaignPlan/CampaignPlanLoader';
import { useLocation } from 'react-router-dom';

const CampaignPlans = () => {
    const location = useLocation();
    const fetchCampaignsLoading = useAppSelector(getCampaignsLoading);
    const defaultCampaigns = useAppSelector(getDefaultCampaigns);
    const brandCampaigns = useAppSelector(getBrandCampaigns);

    const suggestedPlansRef = useRef<HTMLDivElement>(null);
    const [selectingPlanId, setSelectingPlanId] = useState<string | null>(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (
            params.get('suggested') === 'true' &&
            suggestedPlansRef.current &&
            defaultCampaigns.length > 0
        ) {
            setTimeout(() => {
                suggestedPlansRef.current?.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
    }, [location.search, defaultCampaigns]);

    return (
        <div className="tw-w-full tw-flex tw-flex-col tw-pt-10 tw-min-w-5xl tw-px-5">
            {fetchCampaignsLoading ? (
                <div className="tw-w-full">
                    <div className="tw-font-bold tw-mb-4">Fetching Plans...</div>
                    <div className="tw-flex tw-flex-wrap tw-gap-4">
                        {[...Array(6)].map((_, i) => (
                            <CampaignPlanLoader key={i} />
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    {brandCampaigns.length > 0 && (
                        <div className="tw-w-full">
                            <div className="tw-font-bold tw-mb-4">Your Plans</div>
                            <div className="tw-flex tw-flex-wrap tw-gap-4">
                                <NewCampaignPlan
                                    selectingPlanId={selectingPlanId}
                                    setSelectingPlanId={setSelectingPlanId}
                                />
                                {brandCampaigns.map((campaign) => (
                                    <CampaignPlan
                                        campaign={campaign}
                                        selectingPlanId={selectingPlanId}
                                        setSelectingPlanId={setSelectingPlanId}
                                    />
                                ))}
                            </div>
                        </div>
                    )}

                    {defaultCampaigns.length > 0 && (
                        <div className="tw-w-full tw-mt-20" ref={suggestedPlansRef}>
                            <div className="tw-font-bold tw-mb-4">Suggested Plans For You</div>
                            <div className="tw-flex tw-flex-wrap tw-gap-4">
                                {defaultCampaigns.map((campaign) => (
                                    <CampaignPlan
                                        campaign={campaign}
                                        selectingPlanId={selectingPlanId}
                                        setSelectingPlanId={setSelectingPlanId}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default CampaignPlans;
